/* PHESIA - urun kartindaki renk kutucuguna tiklayinca gorseli ve linki degistirir.
   8 Eylul 2026. Yakalama (capture) fazinda calisir ki temanin kendi .swatch
   dinleyicisi ile catismasin. */
(function () {
  'use strict';

  function applySwatch(sw) {
    var card = sw.closest('.product-card');
    if (!card) return;

    var src = sw.getAttribute('data-swatch-img');
    if (src) {
      var main = card.querySelector('.product-media img.main');
      var alt = card.querySelector('.product-media img.alt');
      if (main) {
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.setAttribute('src', src);
        main.setAttribute('loading', 'eager');
      }
      if (alt) {
        alt.removeAttribute('srcset');
        alt.removeAttribute('sizes');
        alt.setAttribute('src', src);
      }
    }

    var url = sw.getAttribute('data-swatch-url');
    if (url) {
      var media = card.querySelector('a.product-media');
      if (media) media.setAttribute('href', url);
      var titleLink = card.querySelector('.product-info h3 a');
      if (titleLink) titleLink.setAttribute('href', url);
    }

    var group = sw.parentNode;
    if (group) {
      var all = group.querySelectorAll('.swatch');
      for (var i = 0; i < all.length; i++) all[i].classList.remove('active');
    }
    sw.classList.add('active');
  }

  function findSwatch(target) {
    if (!target || !target.closest) return null;
    return target.closest('.swatch[data-card-swatch]');
  }

  document.addEventListener('click', function (e) {
    var sw = findSwatch(e.target);
    if (!sw) return;
    e.preventDefault();
    e.stopPropagation();
    applySwatch(sw);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var sw = findSwatch(e.target);
    if (!sw) return;
    e.preventDefault();
    e.stopPropagation();
    applySwatch(sw);
  }, true);
})();